export const PROVIDERS = {
    FACEBOOK: 'facebook',
    APPLE: 'apple',
    GOOGLE: 'google',
    KLARNA: 'klarna'
};

export const PROVIDER_NAMES = {
    [PROVIDERS.FACEBOOK]: 'Facebook',
    [PROVIDERS.APPLE]: 'Apple',
    [PROVIDERS.GOOGLE]: 'Google',
    [PROVIDERS.KLARNA]: 'Klarna'
};

export const FUNNEL_PASSWORD = 'password';
export const FUNNEL_APPLE = PROVIDERS.APPLE;
export const FUNNEL_FACEBOOK = PROVIDERS.FACEBOOK;
export const FUNNEL_GOOGLE = PROVIDERS.GOOGLE;
export const FUNNEL_KLARNA = PROVIDERS.KLARNA;
